import React from 'react';
import {
  BarChart, Bar, XAxis, YAxis, Tooltip as RechartsTooltip, ResponsiveContainer
} from 'recharts';
import { Grid, Paper, Typography, Skeleton } from '@mui/material';

const CustomTooltip = ({ active, payload }) => {
  if (!active || !payload?.length) return null;

  const { product, daysRemaining } = payload[0].payload;

  return (
    <Paper elevation={3} sx={{ p: 1 }}>
      <Typography variant="subtitle2">{product}</Typography>
      <Typography variant="body2">⏳ Días restantes: {daysRemaining}</Typography>
    </Paper>
  );
};

const ProjectedStockoutsByBranchGrid = ({ data = {}, branches = [], loading }) => {
  if (!branches.length) return null;

  return (
    <Grid container spacing={2} mt={0} mb={6} >
      {branches.map((branch, index) => {
        const branchData = [...(data[branch.id] || [])].sort((a, b) => a.daysRemaining - b.daysRemaining);

        return (
          <Grid item xs={12} md={4} key={branch.id}>
            <Paper elevation={2} sx={{ p: 2, height: 340 }}>
              <Typography variant="subtitle1" gutterBottom>
                ⏳ Proyección de quiebre – {branch.name}
              </Typography>
              {loading ? (
                <Skeleton variant="rectangular" height={300} />
              ) : (
                <ResponsiveContainer width="100%" height={300}>
                  <BarChart data={branchData} layout="vertical" margin={{ top: 10, left: 10, right: 20, bottom: -10 }}>
                    <XAxis type="number" />
                    <YAxis
                      type="category"
                      dataKey="product"
                      tickFormatter={(v) => v.length > 18 ? v.slice(0, 18) + '…' : v}
                      width={120}
                    />
                    <RechartsTooltip content={<CustomTooltip />} />
                    <Bar dataKey="daysRemaining" fill={branch.color} />
                  </BarChart>
                </ResponsiveContainer>
              )}
            </Paper>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default ProjectedStockoutsByBranchGrid;
